import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('authenticate', {
    // isLoggedIn: (state) => state.id_token,
  }),
  ...mapGetters('authenticate', ['isLoggedIn', 'authStatus']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarTheme: (state) => state.leftSidebarTheme,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
  }),
}

export const authenticateMethods = mapActions('authenticate', [
  'login',
])

export const layoutMethods = mapActions('layout', [
  'changeLayoutType',
  'changeLeftSidebarTheme',
  'changeLeftSidebarType',
  'changeLayoutWidth',
])
